import { TrackSource } from '@livekit/protocol'
import type { LocalParticipant } from 'livekit-client'

type MicrophonePermissions = Pick<NonNullable<LocalParticipant['permissions']>, 'canPublish' | 'canPublishSources'>

export function canPublishMicrophone(permissions?: MicrophonePermissions): boolean {
  // LiveKit treats an omitted or empty source list as unrestricted publishing.
  return permissions?.canPublish === true &&
    (!permissions.canPublishSources?.length ||
      permissions.canPublishSources.includes(TrackSource.MICROPHONE))
}

export function isRoomMicrophoneBlocked(metadata?: string): boolean {
  try { return JSON.parse(metadata || '{}')?.blockUserMic === true }
  catch { return false }
}
